module.exports = __webpack_public_path__ + "assets/right-arrow@2x.png?9a5181b3be034c4aa6c6bc5d25acef17";